<template>
  <ZigzagServiceLayout
    mainTitle="Terapias Vitamínicas IM/IV"
    mainDescription="Energía, equilibrio y bienestar desde adentro hacia afuera. Nuestras terapias intravenosas entregan hidratación, nutrientes y antioxidantes, administradas bajo supervisión médica para apoyar la hidratación y el bienestar."
    :sections="sections"
  />
</template>

<script>
import ZigzagServiceLayout from '../../../components/ZigzagServiceLayout.vue';

export default {
  name: 'IMIVVitaminTherapiesContentEs',
  components: {
    ZigzagServiceLayout,
  },
  data() {
    return {
      sections: [
        {
          label: 'HIDRATACIÓN Y RECUPERACIÓN',
          title: 'Bienestar e Hidratación Corporal',
          subtitle: 'Restaure el equilibrio con electrolitos, vitaminas y antioxidantes.',
          paragraphs: [
            "Nuestras terapias IV están diseñadas para reponer rápidamente los líquidos y nutrientes esenciales de su cuerpo.",
            "Ya sea que necesite una vía intravenosa de recuperación pos-viaje o estrés, nuestras infusiones supervisadas brindan un alivio inmediato y un bienestar duradero."
          ],
          list: [
            "Hidratación corporal completa con electrolitos",
            "Apoyo antioxidante para la salud inmunológica",
            "Recuperación rápida de la fatiga y estrés",
            "Alivio de los síntomas del viaje/jet lag"
          ],
          image: '/images/services/iv-hydration.png'
        },
        {
          label: 'RENDIMIENTO',
          title: 'Bienestar y Equilibrio Nutricional',
          subtitle: 'Apoye el bienestar general y el equilibrio nutricional.',
          paragraphs: [
            "Infusiones adaptadas con B12, aminoácidos esenciales y vitaminas para optimizar sus niveles de energía y función metabólica.",
            "Estas terapias son ideales para apoyar el control de peso de manera segura y acelerar la recuperación después del ejercicio intenso."
          ],
          list: [
            "B12 y aminoácidos para impulsos de energía naturales",
            "Apoyo para el bienestar general y el equilibrio nutricional",
            "Recuperación muscular más rápida",
            "Enfoque y vitalidad mejorados"
          ],
          image: '/images/services/iv-energy.png'
        },
        {
          label: 'ESTÉTICA',
          title: 'Salud y Rejuvenecimiento de la Piel',
          subtitle: 'Apoye su piel, cabello y brillo natural.',
          paragraphs: [
            "Nutra su belleza desde dentro. Nuestras mezclas de vitaminas especializadas apoyan el cabello sano y la piel radiante.",
            "Estos goteos rejuvenecedores son completamente seguros y están formulados para realzar su resplandor natural y combatir el envejecimiento."
          ],
          list: [
            "Mezclas de vitaminas para un brillo natural y radiante",
            "Apoyo para el crecimiento saludable del cabello y uñas",
            "Protección antioxidante antienvejecimiento",
            "Hidratación para una piel tersa y juvenil"
          ],
          image: '/images/services/iv-beauty.png'
        }
      ]
    };
  }
};
</script>
